import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Violation } from '../models';

@Injectable({ providedIn: 'root' })
export class MediaZipService {

  constructor(private http: HttpClient) { }

  async downloadZip(violation: Violation) {
    const zip = (window as any).zip;
    const files = violation.files;

    for (const file of files) {
      const blob = await this.fetchBlobFromS3(file.urlCurrent);
      const ext = file.type === 'video' ? '.mp4' : '.jpeg';
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      zip.file(`${violation.passId}-${file.type}${ext}`, blob!);
    }

    const zipBlob = await zip.generateAsync({ type: 'blob' });

    this.triggerDownload(zipBlob, `${violation.passId}-midias.zip`);
  }

  private triggerDownload(blob: Blob, filename: string) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  }

  private async fetchBlobFromS3(signedUrl: string): Promise<Blob> {
    const response = await fetch(signedUrl);
    if (!response.ok) {
      throw new Error('Erro ao baixar mídia do S3');
    }
    return await response.blob();
  }
}
